import React from 'react';
import { Bird, Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle2 } from 'lucide-react';

export const TurkeyPackageSection = ({ t }) => {
  if (!t.turkeyPackage) return null;

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const pkg = t.turkeyPackage.package;
  const features = pkg.features || [];

  return (
    <section id="turkey-package" className="py-20 bg-stone-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Bird className="h-12 w-12 text-orange-500" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.turkeyPackage.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold">
            Forfait Spécial avec Guide Professionnel Inclus
          </p>
        </div>

        <Card className="bg-gradient-to-br from-orange-500/10 to-stone-800 border-orange-500 shadow-xl shadow-orange-500/20 max-w-2xl mx-auto relative">
          <div className="absolute top-0 right-0 z-10">
            <div className="bg-orange-500 text-white rounded-none rounded-bl-lg px-4 py-2 flex items-center">
              <Star className="h-4 w-4 mr-1 fill-current" />
              Guide Inclus
            </div>
          </div>

          <CardHeader className="text-center pb-8 pt-10">
            <CardTitle className="text-3xl text-orange-500 mb-2">
              {pkg.name}
            </CardTitle>
            <CardDescription className="text-gray-300 text-lg mb-4">
              {pkg.duration}
            </CardDescription>
            <div className="flex items-baseline justify-center">
              <span className="text-6xl font-bold text-white">${pkg.price}</span>
              <span className="text-gray-400 ml-2 text-xl">/pers</span>
            </div>
          </CardHeader>

          <CardContent className="space-y-6 px-8 pb-8">
            <ul className="space-y-3">
              <li className="flex items-start text-gray-300 text-lg">
                <CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[0] || 'Feature 1'}</span>
              </li>
              <li className="flex items-start text-gray-300 text-lg">
                <CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[1] || 'Feature 2'}</span>
              </li>
              <li className="flex items-start text-gray-300 text-lg">
                <CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[2] || 'Feature 3'}</span>
              </li>
              <li className="flex items-start text-gray-300 text-lg">
                <CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[3] || 'Feature 4'}</span>
              </li>
              <li className="flex items-start text-gray-300 text-lg">
                <CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[4] || 'Feature 5'}</span>
              </li>
              <li className="flex items-start text-gray-300 text-lg">
                <CheckCircle2 className="h-6 w-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
                <span>{features[5] || 'Feature 6'}</span>
              </li>
            </ul>

            <Button
              onClick={scrollToContact}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-6 text-lg transition-all duration-300 hover:scale-105"
            >
              Réserver Ce Forfait Spécial
            </Button>

            <div className="text-center text-gray-400 text-sm mt-4">
              <p>* Prix incluant le guide professionnel</p>
              <p className="text-orange-500 font-bold text-base mt-2">
                💰 30% de dépôt à la réservation
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
